import request from '@core/services/request';

export const marketScanAPI = {
	getRebateParams: (fimenu: any) => request.post(`/MarketScan/GetRebateParams`, fimenu),
	getRebateDescription: (mscanaccount: any, rebateId: any) => {
		return request.get(`/MarketScan/GetRebateDescription/${mscanaccount}/${rebateId}`);
	},
	getVehiclesByVIN: (mscanaccount: any, vin: any, isNew: any) => {
		return request.get(`/MarketScan/GetVehiclesByVIN/${mscanaccount}/${vin}/${isNew}`);
	},
	getMarketScanMakesModels: () => request.get(`/MarketScan/GetMarketScanMakesModels`),
	getMarketScanVehicleById: (id: any) => request.get(`/MarketScan/GetMarketScanVehicleById/${id}`),
	getYearsForMakeModel: (mscanaccount: any, makeId: any, modelId: any, isNew: any) => {
		return request.get(`/MarketScan/GetYearsForMakeModel/${mscanaccount}/${makeId}/${modelId}/${isNew}`);
	},
	getVehiclesModelYear: (mscanaccount: any, modelId: any, year: any, isNew: any) => {
		return request.get(`/MarketScan/GetVehiclesModelYear/${mscanaccount}/${modelId}/${year}/${isNew}`);
	},
	runScan: (mscanaccount: any, apiRequest: any) => request.post(`/MarketScan/RunScan/${mscanaccount}`, apiRequest),
};
